import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { DropdownStyles } from './styles';
import Button from '../../components/Button';
import { DownloadIconTwo, StatusRequested, UploadIcon } from '../../components/icons';
import ConfirmModal from './ConfirmModal';
import { BiFileBlank } from 'react-icons/bi';
import TextArea from '../OrderEntry/ui/TextArea';
import UploadSdaModal from './UploadSdaModal';
import { MdOutlineAddBox } from 'react-icons/md';
import { FiDownload, FiUpload } from 'react-icons/fi';

interface Props {
  status: any;
  download: (props: any) => void;
  searchType: string;
  viewPdf: () => Promise<void>;
  sdaOpen?: any;
  updateSearch: (note: string) => void;
  downloadSda: () => void;
}
const SearchActionsDropdown = (props: Props) => {
  const [updateOrder, setUpdateOrder] = useState(false);
  const [note, setNote] = useState('');
  return (
    <>
      <DropdownStyles>
        {props.status === 'Completed' && (
          <>
            <Button
              onClick={(e: MouseEvent) => {
                e.stopPropagation();
                props.download(props);
              }}
              buttonType="ButtonSecondaryMedium"
              buttonText="Download"
              icon={<DownloadIconTwo />}
            />
            <Button
              onClick={async (e: MouseEvent) => {
                e.stopPropagation();
                await props.viewPdf();
              }}
              buttonType="ButtonSecondaryMedium"
              buttonText="View PDF"
              icon={<BiFileBlank />}
            />
          </>
        )}
        {props.status === 'Completed' && (
          <Button
            onClick={(e: MouseEvent) => {
              e.stopPropagation();
              setUpdateOrder(true);
            }}
            buttonType="ButtonSecondaryMedium"
            buttonText={props.searchType.includes('Tax') ? 'Order Tax Contin' : 'Order Updated Search'}
            width={props.searchType.includes('Tax') ? '155px' : '190px'}
            icon={<MdOutlineAddBox />}
          />
        )}
        {props.status === 'SDA Requested' && (
          <div style={{ display: 'flex' }}>
            <Button
              onClick={(e: MouseEvent) => {
                e.stopPropagation();
                props.downloadSda();
              }}
              buttonType="ButtonSecondaryMedium"
              buttonText="Download SDA Form"
              icon={<FiDownload />}
              width={200}
            />
            <Button
              onClick={(e: MouseEvent) => {
                e.stopPropagation();
                props.sdaOpen();
              }}
              buttonType="ButtonSecondaryMedium"
              buttonText="Upload SDA"
              icon={<FiUpload />}
            />
          </div>
        )}
      </DropdownStyles>
      {updateOrder && (
        <ConfirmModal
          buttonText="Confirm"
          header={`Add ${props.searchType.includes('Tax') ? 'Tax Contin' : props.searchType} ${
            !props.searchType.includes('Tax') ? 'Update' : ''
          } to this order`}
          onClose={() => setUpdateOrder(false)}
          onConfirmAction={() => {
            setUpdateOrder(false);
            props.updateSearch(note);
          }}
          open={updateOrder}
          children={
            <TextArea
              error=""
              label="Note"
              value={note || ''}
              placeholder={'Enter your notes here'}
              onChange={(e: any) => {
                setNote(e.target.value);
              }}
              styles={{ width: 400, ' :focus': { outline: 'none' }, caretColor: '#8e8e93' }}
            />
          }
        />
      )}
    </>
  );
};

export default SearchActionsDropdown;
